import { Layout } from '@/features/auth/components/Layout';
import { useTranslation } from 'react-i18next';

export const RegistrationCompletePage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <p className="mt-3 text-gray-900">
        {t('RuleWatcher に 仮登録しました。')}
      </p>
      <p className="mt-3 text-gray-900">
        {t(
          'ご入力いただいたメールアドレス宛てに、本人確認メールをお送りいたしました。'
        )}
        {t('お送りした確認メールのリンクから本登録してください。')}
      </p>
    </Layout>
  );
};
